import type { GridPosition, SlotGrid } from '../rendering/types';

export interface ReelAnticipation {
  readonly reel: number;
  readonly hasScatter: boolean;
  readonly anticipated: boolean;
  readonly scatterReelsBefore: number;
  readonly scatterStageAtStop: 0 | 1 | 2 | 3;
}

export function getScatterReels(
  grid: SlotGrid,
  blockers: readonly GridPosition[] = [],
): readonly boolean[] {
  const blocked = new Set(blockers.map((position) => `${position.reel}:${position.row}`));
  return grid.map((reel, reelIndex) => reel.some((symbol, row) => (
    symbol === 'SCATTER' && !blocked.has(`${reelIndex}:${row}`)
  )));
}

export function createScatterAnticipationPlan(
  grid: SlotGrid,
  blockers: readonly GridPosition[] = [],
): readonly ReelAnticipation[] {
  const scatterReels = getScatterReels(grid, blockers);
  let seen = 0;
  return scatterReels.map((hasScatter, reel) => {
    const entry: ReelAnticipation = {
      reel,
      hasScatter,
      anticipated: reel > 0 && seen >= 2,
      scatterReelsBefore: seen,
      scatterStageAtStop: Math.min(3, seen + (hasScatter ? 1 : 0)) as 0 | 1 | 2 | 3,
    };
    if (hasScatter) seen += 1;
    return entry;
  });
}
